import { defineComponent as _defineComponent } from 'vue'
import { ref, nextTick } from 'vue';
import PannableViewport from './PannableViewport.vue';
import { useEsc } from '@/ui/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ZoomToggleContainer',
  emits: ['zoom-state-enter', 'zoom-state-leave'],
  setup(__props, { emit }) {



const rootElement = ref<HTMLElement | undefined>();
const zoomedElement = ref<InstanceType<typeof PannableViewport> | undefined>();
const isZoomed = ref(false);

let blockZoomToggle = false;

const toggleZoom = () => {
    if (blockZoomToggle) {
        return;
    }
    blockZoomToggle = true; // prevent double-toggling
    if (isZoomed.value) {
        emit('zoom-state-leave');
    } else {
        emit('zoom-state-enter');
    }
    isZoomed.value = !isZoomed.value;
    setTimeout(() => {
        blockZoomToggle = false;
    }, 200);
};

useEsc(() => {
    isZoomed.value = false;
});

const handleRegularClick = async(event: MouseEvent) => {
    event.stopPropagation();
    if (!zoomedElement.value || !rootElement.value) {
        return;
    }
    if (isZoomed.value) {
        toggleZoom();
    } else {
        toggleZoom();
        await nextTick(); // Ensure the zoomed viewport is rendered

        const rect = rootElement.value.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        zoomedElement.value.clickPan(x, y);
    }
};

const handleZoomedClick = (event: MouseEvent) => {
    event.stopPropagation();
    toggleZoom();
};

return { __sfc: true,emit, rootElement, zoomedElement, isZoomed, blockZoomToggle, toggleZoom, handleRegularClick, handleZoomedClick, PannableViewport }
}

})